import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import axios from "axios";
import FormatDate from "./FormatDate";
import TemperatureMetric from "./TemperatureMetric";
import WeekForecast from "./WeekForecast";
import WeatherIcon from "./WeatherIcon";

export default function App(props) {
  const [weatherInfo, setWeatherInfo] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    console.log(response);
    setWeatherInfo({
      ready: true,
      coord: response.data.coord,
      temperature: Math.round(response.data.main.temp),
      city: response.data.name,
      date: new Date(response.data.dt * 1000),
      description: response.data.weather[0].description,
      humidity: response.data.main.humidity,
      icon: response.data.weather[0].icon,
      wind: response.data.wind.speed,
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function updateCity(event) {
    setCity(event.target.value);
  }

  function search() {
    const apiKey = "58a6775f97527351bf6c6966e209be39";
    const apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;

    axios.get(apiUrl).then(handleResponse);
  }

  if (weatherInfo.ready) {
    return (
      <div className="App">
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-9">
                <input
                  type="search"
                  placeholder="Enter a city..."
                  className="form-control"
                  autoFocus="on"
                  onChange={updateCity}
                />
              </div>
              <div className="col-3">
                <input
                  type="submit"
                  value="Search"
                  className="btn btn-primary w-100"
                />
              </div>
            </div>
          </form>
        </div>
        <div className="container">
          <div className="row">
            <h1 className="app-city">{weatherInfo.city}</h1>
            <ul className="app-weather">
              <li>
                <FormatDate date={weatherInfo.date} />
              </li>
              <li className="text-capitalize">{weatherInfo.description}</li>
            </ul>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-6">
              <WeatherIcon
                className="weatherIcon"
                code={weatherInfo.icon}
                size={52}
              />

              <TemperatureMetric celsius={weatherInfo.temperature} />
            </div>
            <div className="col-6">
              <ul className="app-humidity-wind">
                <li>Humidity: {weatherInfo.humidity}%</li>
                <li>Wind: {weatherInfo.wind} km/h</li>
              </ul>
            </div>
          </div>
        </div>
        <WeekForecast coordinates={weatherInfo.coord} />
      </div>
    );
  } else {
    search();
    return <div>Loading...</div>;
  }
}
